import { ar } from './ar';
import { bg } from './bg';
import { ca } from './ca';
import { da } from './da';
import { de } from './de';
import { el } from './el';
import { en } from './en';
import { es } from './es';
import { et } from './et';
import { fi } from './fi';
import { fr } from './fr';
import { he } from './he';
import { it } from './it';
import { ja } from './ja';
import { ka } from './ka';
import { ko } from './ko';
import { nb } from './nb';
import { nl } from './nl';
import { pl } from './pl';
import { pt } from './pt';
import { ru } from './ru';
import { sv } from './sv';
import { th } from './th';
import { tr } from './tr';
import { zhS } from './zhS';
import { zhT } from './zhT';

export const strings = {
  en,
  ar,
  bg,
  ca,
  da,
  de,
  el,
  es,
  et,
  fi,
  fr,
  he,
  it,
  ja,
  ka,
  ko,
  nb,
  nl,
  pl,
  pt,
  ru,
  sv,
  th,
  tr,
  zhS,
  zhT
};
